import React, { useState, useCallback } from "react";
import Slider from "react-slick";
import ImageViewer from "react-simple-image-viewer";

import "./Gallery.scss";


import image1 from "./images/image1.webp";
import image2 from "./images/image2.webp";
import image3 from "./images/image3.webp";
import image4 from "./images/image4.webp";
import image5 from "./images/image5.webp";
import image6 from "./images/image6.webp";
import image7 from "./images/image7.webp";
import image8 from "./images/image8.webp";
import image9 from "./images/image9.webp";


const settings = {
  className: "center",
  centerMode: true,
  infinite: true,
  centerPadding: "0",
  slidesToShow: 3,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 500,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const Gallery = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };
  const images = [image1, image2, image3, image4, image5, image6, image7, image8, image9];

  return (
    <div className="root">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} onClick={() => openImageViewer(image)}>
            <img src={image} alt="gallery" />
          </div>
        ))}
      </Slider>
      {isViewerOpen && (
        <ImageViewer
          src={[currentImage]}
          currentIndex={0}
          disableScroll={false}
          closeOnClickOutside={true}
          onClose={closeImageViewer}
        />
      )}
    </div>
  );
};

export default Gallery;
